import { Avatar, Dropdown, Row, Typography } from 'antd'
import CardDropdown from 'components/CardDropdown'
import { Colors } from 'constants/Colors'
import { Translate } from 'lang'
import selectIcon from 'utils/selectIcon'

const { Text } = Typography

const DeviceIcons = ({ value }) => {
  const helperIcon = icon => {
    switch (icon) {
      case 'collar': {
        return 'hardware-devices'
      }
      case 'tag': {
        return 'hardware-tags'
      }
      case 'mobile_router': {
        return 'hardware-router-mobile'
      }
      default: {
        return '-'
      }
    }
  }
  const getText = text => {
    switch (text) {
      case 'collar':
        return 'devices'
      case 'tag':
        return 'tag'
      case 'mobile_router':
        return 'router_mobile'
      default:
        return 'devices'
    }
  }

  if (!value) return '-'
  return (
    <Row style={{ gap: '5%' }}>
      {value
        ?.filter(item => item.has === true)
        ?.map((item, index) => {
          const stylesItens = {
            display: 'flex',
            flexDirection: 'column',
            padding: '5px 13px',
          }

          const items = [
            {
              label: Translate({ messageKey: getText(item.type), howMany: 'one' }),
              value: (
                <Text strong style={{ display: 'inline-block' }}>
                  {item?.name}
                </Text>
              ),
              separator: '',
              style: stylesItens,
            },
            {
              label: Translate({ messageKey: 'last_update' }),
              value: (
                <Text strong style={{ display: 'inline-block' }}>
                  {item?.last_activity}
                </Text>
              ),
              separator: '',
              style: stylesItens,
            },
          ]
          const DropdownItens = [
            {
              key: 'status-dashboard',
              type: 'group',
              label: <CardDropdown items={items} />,
            },
          ]
          return (
            <Dropdown
              menu={{
                items: DropdownItens,
              }}
              placement="topCenter"
            >
              <Avatar
                key={`${item.type}-${item.name}-${index}`}
                size={32}
                style={{
                  backgroundColor: item?.has_package_in_24_hours
                    ? Colors.primary
                    : Colors.gray_light,
                }}
              >
                <img src={selectIcon(helperIcon(item?.type))} alt="device icons" />
              </Avatar>
            </Dropdown>
          )
        })}
    </Row>
  )
}

export default DeviceIcons
